import * as types from './mutation-types'
import Vue from 'vue'
import { IEnseigneState } from './state'
import { MutationTree } from 'vuex/types'
import { AloDbEnseigne, IAloDbEnseigneConstParam } from '@/models/alodb/AloDbEnseigne';
import glider from '@/api/glider';
import {i18n} from '@/locale/vueI18n'
/*
  Need to use export default({}) rather than export default {}
  ref links: https://github.com/TypeStrong/ts-loader/issues/588
*/
const mutations:MutationTree<IEnseigneState> = {
     
    //Gestion des recherches de missions
    [types.ENSEIGNE_REQUEST]: state => {
        state.status = i18n.t('Admin.Loading',{item:i18n.t('Admin.Enseigne.Title').toString()}).toString()
        state.enseigneLoading = true
    },
    [types.ENSEIGNE_SUCCESS]: (state, enseignes:Array<AloDbEnseigne>) => {
        state.status = i18n.t('Admin.LoadingOk',{item:i18n.t('Admin.Enseigne.Title').toString()}).toString()
        state.enseignes = enseignes          
        state.enseigneLoading = false      
    },
    [types.ENSEIGNE_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.Enseigne.Title').toString()}).toString()
        state.enseignes = []
        state.enseigneLoading = false
    },
    [types.ENSEIGNE_SELECT_DETAIL_REQUEST]: (state, itemId:number) => {
        state.status = i18n.t('Admin.Loading',{item:`${i18n.t('Admin.Enseigne.Title').toString()} ${itemId}`}).toString()
        state.enseigneLoading = true
    },
    [types.ENSEIGNE_SELECT_DETAIL_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.Enseigne.Title').toString()}).toString()
        state.enseigneLoading = false
    },
    [types.ENSEIGNE_SELECT_DETAIL_SUCCESS]: (state,enseigne:AloDbEnseigne) => {
        state.status = i18n.t('Admin.LoadingOk',{item:`${i18n.t('Admin.Enseigne.Title').toString()} ${enseigne.ENS_ID}`}).toString()        
        //1, on met à jour de m'enseigne dans la liste des enseignes
        const index = state.enseignes.findIndex(m => m.ENS_ID == enseigne.ENS_ID)
        state.enseignes.splice(index == -1 ? state.enseignes.length : index, index == -1 ? 0 : 1, enseigne)
        state.enseigneLoading = false
    },
    [types.ENSEIGNE_SELECT_DETAIL]: (state,enseigne:AloDbEnseigne) => {                
        state.originalAdmEnseigne = enseigne
        state.modifiedAdmEnseigne = new AloDbEnseigne({...enseigne,ENS_DATADD:enseigne.ENS_DATADD? enseigne.ENS_DATADD.toUTCString():null} as IAloDbEnseigneConstParam)
    },
    [types.ENSEIGNE_SAVE_REQUEST]: (state,libelle:string) => {
        state.status = i18n.t('Admin.SaveItem',{item:`${i18n.t('Admin.Enseigne.Title').toString()} ${libelle}`}).toString()
        state.enseigneLoading = true
    },
    [types.ENSEIGNE_SAVE_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorSave',{item:i18n.t('Admin.Enseigne.Title').toString()}).toString()
        state.enseigneLoading = false
    },
    [types.ENSEIGNE_UPDATE_MODIFIED_ADM]: (state, newProperties:Object) => {        
        state.modifiedAdmEnseigne = {...state.modifiedAdmEnseigne,...newProperties}
    },
    [types.ENSEIGNE_UPDATE_FILTER_ADM]: (state, newProperties:Object) => {        
        state.adminFilter = {...state.adminFilter,...newProperties}
    } 
}


export default mutations
